import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_b_button = _resolveComponent("b-button");
  return _openBlock(), _createBlock(_component_b_button, {
    class: "wrap-with-highlight",
    onClick: _cache[0] || (_cache[0] = $event => _ctx.$emit('click')),
    disabled: $props.loading || $props.disabled
  }, {
    default: _withCtx(() => [_renderSlot(_ctx.$slots, "default", {}, undefined, true)]),
    _: 3
  }, 8, ["disabled"]);
}